import React, { useState, useEffect } from 'react'
import DebtManagement from './DebtManagement'
import DebtManagementDashboard from './DebtManagementDashboard'
import KPIDebtManagementDashboard from './KPIDebtManagementDashboard'
import KPILoanManagementDashboard from './KPILoanManagementDashboard'
import LoanDashboard from './LoanDashboard'
import LoanPortfolioReview from './LoanPortfolioDash/Main'
import PaymentsCollected from './PaymentsCollected'
import RevenueOperationalExpenses from './RevenueOperationalExpenses'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getNBFCList } from './DebtListActionCreator'
import NPALeadsContainer from './NPALeads.container'
import { BorderRight } from '@mui/icons-material'
export default function DebtListMain({ pageViewHandler, admin, allStatus,newDataBackground }) {
    const [activeTab, setActiveTab] = useState('debtManagement')
    const [detailView, setDetailView] = useState(false)
    const [nbfcList, setnbfcList] = useState([])

    const maxHeight = window.innerWidth > 1300 ? '60px' : '75px'
    const sectionStyle = {
        padding: (activeTab === 'debtManagement' || activeTab == 'KPILoanManagmentDashboard') && detailView == true ? '0px' : window.innerWidth > 1800 ? '20px' : '70px 20px'
    }
    const BackBtnStyle = {
        height: maxHeight,
        width: '100px',
        padding: '10px',
        textAlign: 'center',
        backgroundColor: '#006c67',
        color: '#fff',
        cursor: 'pointer',
    }

    const ActiveTabStyle ={
        backgroundColor:'#006c67',
        color:'#fff',
        borderRadius:'6px',
        fontSize:'12px'
    }
    const TabStyle={
        fontSize:'12px'
    }

    useEffect(() => {
        getNBFCListAPI()
    }, [])

    const getNBFCListAPI = () => {
        getNBFCList((callback) => {
            console.log(callback)
            if (callback) {
                setnbfcList(callback)
            } else {
                setnbfcList([])
            }
        })
    }
    const handleTabs = (type) => {
        setActiveTab(type)
    }

    const detailViewHandler = (type) => {
        setDetailView(type)
    }

    return (
        <>
            <div className="DebtListMain">
                {/* {
                    !detailView ?
                        <div className="tabs" style={{ display: 'flex' }}>
                            <div className="" style={BackBtnStyle} id="debtListTabs" onClick={(e) => pageViewHandler(e, 'landingPage')}>
                                <ExitToAppIcon style={{ fontSize: '30px', margin: '7px 20px 10px 0px', transform: 'rotateY(180deg)' }} />
                            </div>
                            <div style={{ width: '100%' }}>
                                <div className="row">
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'debtManagement' ? 'active' : ''}`} onClick={() => handleTabs('debtManagement')} style={{ height: maxHeight }} id="debtListTabs">
                                        <h5>Debt Management</h5>
                                    </div>
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'KPIDebtManagement' ? 'active' : ''}`} onClick={() => handleTabs('KPIDebtManagement')} style={{ height: maxHeight }} id="debtListTabs">
                                        <h5>KPI Debt Managment</h5>
                                    </div>
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'DebtManagmentDashboard' ? 'active' : ''}`} onClick={() => handleTabs('DebtManagmentDashboard')} style={{ height: maxHeight }} id="debtListTabs">
                            <h5>Debt Management Dashboard</h5>
                        </div>
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'KPILoanManagmentDashboard' ? 'active' : ''}`} onClick={() => handleTabs('KPILoanManagmentDashboard')} style={{ height: maxHeight }} id="debtListTabs">
                                        <h5>KPI Loan Managament</h5>
                                    </div>
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'Paymentscollected' ? 'active' : ''}`} onClick={() => handleTabs('Paymentscollected')} style={{ height: maxHeight }} id="debtListTabs">
                                        <h5>Payments collected</h5>
                                    </div>
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'LoanPortfolio' ? 'active' : ''}`} onClick={() => handleTabs('LoanPortfolio')} style={{ height: maxHeight }} id="debtListTabs">
                                        <h5>Loan Portfolio Review</h5>
                                    </div>
                                    <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'RevenueOperation' ? 'active' : ''}`} onClick={() => handleTabs('RevenueOperation')} style={{ height: maxHeight }} id="debtListTabs">
                                        <h5>Revenue & Operational Expenses</h5>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        : ''} */}
                {
                    !detailView ?
                        <div className="details-new fixed-top">
                            <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }} >
                                <div className="col-sm-3 " style={{ marginTop: '10px' }}>
                                    <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' ,marginLeft:'8px'}} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                                </div>
                                <div className="col-sm-9 col-xs-12" style={{ display: 'flex' }}>
                                    <div className="btn-group-new" style={{ marginLeft: 'auto', marginRight: '20px' }}>
                                        <button className={`NPATabStyle ${activeTab == 'debtManagement' ? "active" : ""}`}  onClick={(e) => handleTabs('debtManagement')}>Debt <br/> Management</button>
                                        <button className={`NPATabStyle ${activeTab == 'KPIDebtManagement' ? "active" : ""}`} onClick={(e) => handleTabs('KPIDebtManagement')}>KPI Debt <br/> Managment</button>
                                        <button className={`NPATabStyle ${activeTab == 'KPILoanManagmentDashboard' ? "active" : ""}`}  onClick={(e) => handleTabs('KPILoanManagmentDashboard')}>KPI Loan <br/> Managment</button>
                                        <button className={`NPATabStyle ${activeTab == 'Paymentscollected' ? "active" : ""}`} onClick={(e) => handleTabs('Paymentscollected')}>Payments <br/> collected</button>
                                        <button className={`NPATabStyle ${activeTab == 'LoanPortfolio' ? "active" : ""}`}   onClick={(e) => handleTabs('LoanPortfolio')}>Loan Portfolio <br/> Review</button>
                                        <button className={`NPATabStyle ${activeTab == 'RevenueOperation' ? "active" : ""}`}  onClick={(e) =>   handleTabs('RevenueOperation')}>Revenue & Operational <br/> Expenses</button>
                                    </div>


                                </div>
                            </div>
                        </div>
                        : ''}
                <div className="Sections" style={sectionStyle}>

                    {
                        activeTab == 'debtManagement' || activeTab == 'KPILoanManagmentDashboard' ?
                            <NPALeadsContainer admin={admin} detailViewHandler={detailViewHandler} activeTab={activeTab} />
                            // <DebtManagement nbfcList={nbfcList} />
                            : ''
                    }
                    {
                        activeTab == 'KPIDebtManagement' ?
                            <KPIDebtManagementDashboard nbfcList={nbfcList} />
                            : ''
                    }
                    {
                        activeTab == 'DebtManagmentDashboard' ?
                            <DebtManagementDashboard />
                            : ''
                    }

                    {
                        activeTab == 'Paymentscollected' ?
                            <PaymentsCollected nbfcList={nbfcList} />
                            : ''
                    }
                    {
                        activeTab == 'RevenueOperation' ?
                            <RevenueOperationalExpenses nbfcList={nbfcList}/>
                            : ''
                    }
                    {
                        activeTab == 'LoanPortfolio' ?
                            <LoanPortfolioReview nbfcList={nbfcList} admin={admin} allStatus={allStatus} newDataBackground={newDataBackground}/>
                            : ''
                    }
                    {
                        activeTab == 'LoanDashboard' ?
                            <LoanDashboard />
                            : ''
                    }
                </div>

            </div>
        </>
    )
}
